import { MatDialogRef } from '@angular/material/dialog';
import { AutomotiveAftermarketProfileDetails } from '../models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class AutomotiveAftermarketProfileItemBriefLoad {
  public static readonly type = '[AutomotiveAftermarketProfileItemBrief] Load';

  constructor(public payload: number) {}
}

export class AutomotiveAftermarketProfileItemBriefSave {
  public static readonly type = '[AutomotiveAftermarketProfileItemBrief] Save';

  constructor(public payload: Partial<AutomotiveAftermarketProfileDetails>) {}
}

export class AutomotiveAftermarketProfileItemBriefClone {
  public static readonly type = '[AutomotiveAftermarketProfileItemBrief] Clone';

  constructor(public payload: Partial<AutomotiveAftermarketProfileDetails>) {}
}

export class AutomotiveAftermarketProfileItemBriefDelete {
  public static readonly type = '[AutomotiveAftermarketProfileItemBrief] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; profileId: number }) {}
}

export class AutomotiveAftermarketProfileItemBriefInitialState {
  public static readonly type = '[AutomotiveAftermarketProfileItemBrief] Set Initial State';
}
